
import React from "react";
import "../style/contact.css";

const SOCIALS = [
    {
        name: "Facebook",
        href: "https://www.facebook.com/luonverak.dev",
        icon: "image/facebook.png",
    },
    {
        name: "Telegram",
        href: "https://t.me/Verak_Luon",
        icon: "/image/telegram.png",
    },
    {
        name: "LinkedIn",
        href: "https://www.linkedin.com/in/luonverak/",
        icon: "/image/linkedin.png",
    },
    {
        name: "GitHub",
        href: "https://github.com/luonverak",
        icon: "/image/github.png",
    },
    {
        name: "YouTube",
        href: "https://www.youtube.com/@luonverak/featured",
        icon: "/image/youtube.png",
    },
    {
        name: "TikTok",
        href: "https://www.tiktok.com/@code_cartel.dev",
        icon: "/image/tik-tok.png",
    },
];

const Contact = () => {
    return (
        <section className="contact " id="contact">
            <div className="contact-header">
                <p className="contact-eyebrow">Get in touch</p>
                <h1>Contact Me</h1>
                <p className="contact-subtitle">
                    Find me on any of these platforms — happy to connect.
                </p>
            </div>

            <div className="contact-grid">
                {SOCIALS.map((social) => (
                    <a
                        key={social.name}
                        href={social.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="contact-card"
                    >
                        <img src={social.icon} alt="" className="contact-icon" />
                        <span className="contact-name">{social.name}</span>
                    </a>
                ))}
            </div>
        </section>
    );
};

export default Contact;
